<template>
  <div class="chat-question">
    <div>
      <!-- <span v-if="question.answers.length" class="text-header">Webinar staff to {{ question.toAll ? 'all' : 'me' }}</span> -->
      <span class="text-header" :class="{'text-muted': question.failures}">{{ $t('chat.me') }}</span>
      <span class="time">{{ displayTime(question.timeAsked) }}</span>
    </div>
    <p :class="{'text-muted': question.failures}">
      <b>{{ $t('questions.q') }}</b> {{ question.text}}
    </p>
    <template v-if="question.answers.length > 0">
      <p v-for="(answer, index) in question.answers" :key="index"
        class="answer" :class="{ private: !answer.public }">
        <b>{{ $t('questions.a') }}</b> {{ answer.answerText || $t('questions.autoResponse') }}
      </p>
    </template>
    <p v-else-if="question.submitting" class="text-status text-muted">{{ $t('questions.submitting') }}</p>
    <p v-else-if="question.failures" class="failure text-status text-danger">
      <i class="togo-icon togo-icon-alert togo-icon-lg"></i> {{ $t('questions.failure') }}
      <b-link class="try-again" @click="send(question)">{{ $t('questions.tryAgain') }}</b-link>
    </p>
    <p v-else class="text-status text-muted">{{ $t('questions.notYetAnswered') }}</p>
  </div>
</template>

<script>
const ChatQuestion = {
  name: 'ChatQuestion',

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  methods: {
    displayTime(time) {
      const locale = this.$store.state.g2wEnv.locale;
      return new Date(time).toLocaleTimeString(locale, {hour: 'numeric', minute: 'numeric'});
    },

    send(question) {
      this.$store.dispatch('g2wSession/questions/submit', {question});
    }
  }
};
export default ChatQuestion;
</script>

<style lang="sass">
  .chat-question
    .text-header
      font-weight: bold

    .try-again
      text-decoration: none

    p
      margin-top: 0
      margin-bottom: 0

      &.text-status
        font-style: italic
        margin-top: 10px

      &.answer
        padding: 3px 0

    .time
      font-size: .85em
      color: grey
      padding-left: 5px
</style>
